import React, {useEffect} from "react"
import Header from "../components/layout/Header"
import Footer from "../components/layout/Footer";
import BelowBanner from "../components/contactus/BelowBanner";
import Banner from "../components/layout/Banner";
import BgImage from "../assets/images/contactus/Banner.png";
import SEO from '../components/SEO';

const ContactUs=()=> {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
        <SEO
          title="Contact Us | Connect for Exceptional Healthcare Support"
          description="Reach out to our dedicated team for outstanding healthcare services in Huntsville. Contact us today to discuss your healthcare needs and experience personalized care at its best."
          url="/contact-us"
        />
        <Header/>
        <Banner
        BgImage={BgImage}
        Title1="Contact Us"
        Title2="Empowering Care,"
        br={<br className="d-block d-md-none d-xl-block"/>}
        Title2_2="Healing Lives:"
        Title3="Your Journey Begins Here." 
        alt="Contact Us Image"
        />
        <BelowBanner/>
        <Footer/>
        </>
        
    )
};

export default ContactUs;